import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CTA_URL, trackCheckoutClick } from '../lib/constants';
type Props = {
  label: string;
  note?: string;
  variant?: 'gold' | 'navy';
  size?: 'md' | 'lg';
  location: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  note,
  variant = 'gold',
  size = 'lg',
  location,
  id,
  className = ''
}: Props) {
  const palette = variant === 'gold' ? 'bg-gold-500 text-white hover:bg-gold-600 shadow-[0_10px_0_-2px_rgba(132,86,33,0.55)] active:shadow-[0_4px_0_-2px_rgba(132,86,33,0.55)]' : 'bg-navy-800 text-white hover:bg-navy-900 shadow-[0_10px_0_-2px_rgba(8,19,31,0.5)] active:shadow-[0_4px_0_-2px_rgba(8,19,31,0.5)]';
  const sizing = size === 'lg' ? 'px-5 py-4 text-[15px] sm:text-lg' : 'px-4 py-3.5 text-[14px] sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-27" data-mp="159gfksqbgs19">
      <motion.a id={id} href={CTA_URL} onClick={() => trackCheckoutClick(location)} whileTap={{
      scale: 0.975,
      y: 3
    }} className={`flex w-full items-center justify-center gap-2 rounded-2xl text-center font-extrabold uppercase leading-tight tracking-tight transition-colors ${palette} ${sizing}`} data-id="element-28" data-mp="15arf2gcqbdmk">
        <span className="text-balance" data-id="element-29" data-mp="3f06yv4he7x0v">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-30" data-mp="3jxqfuc5h6nwi" />
      </motion.a>
      {note ? <p className="mt-3 text-center text-[11.5px] font-medium leading-relaxed text-navy-500 sm:text-sm" data-id="element-31" data-mp="3oviio17nrufh">
          {note}
        </p> : null}
    </div>;
}